module.exports = "/fonts/vendor/@fortawesome/fontawesome-pro/webfa-solid-900.woff2?16e9dbeb2afd22d5cf0e7eeb2b2879ae";